import React from "react";
import { Table, Badge } from "react-bootstrap";

const NowDayTaskList = ({ data, onReload, taskJDs, onEdit, onDelete }) => {
  return (
    <div className="table-responsive">
      <Table hover align="middle" className="mb-0" style={{ fontSize: '0.75rem' }}>
        <thead className="bg-light text-muted text-uppercase">
          <tr>
            <th className="py-3">#</th>
            <th className="py-3">Task Code</th>
            <th className="py-3">Work Detail</th>
            <th className="py-3">Time Range</th>
            <th className="py-3">Hours</th>
            <th className="py-3">Status</th>
            <th className="py-3 text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          {data && data.length > 0 ? (
            data.map((item, index) => (
              <tr key={item.id || index}>
                <td className="text-muted">{index + 1}</td>
                <td className="fw-bold text-primary">
                  {taskJDs?.find(j => String(j.id) === String(item.taskJDId))?.code || "N/A"}
                </td>
                <td style={{ maxWidth: '300px' }} className="text-wrap">
                  {item.taskDetail}
                </td>
                <td>
                  <span className="badge bg-white text-dark border fw-normal px-2 py-1">
                    {item.startTime} - {item.finishTime}
                  </span>
                </td>
                <td className="fw-bold text-dark">{item.hours}h</td>
                <td>
                  <Badge 
                    bg={item.status === "Done" ? "success" : "warning"} 
                    className="rounded-pill px-3 py-1 fw-normal"
                  >
                    {item.status || "Pending"}
                  </Badge>
                </td>
                <td className="text-center">
                  <div className="d-flex justify-content-center gap-2">
                    {/* NÚT EDIT: Gọi onEdit truyền toàn bộ item */}
                    <button 
                      className="btn btn-sm btn-outline-info border-0 p-1 shadow-none" 
                      title="Edit Task"
                      style={{ cursor: 'pointer' }}
                      onClick={() => onEdit && onEdit(item)}
                    >
                      <i className="fas fa-edit"></i>
                    </button>

                    {/* NÚT DELETE: Gọi onDelete truyền id của item */}
                    <button 
                      className="btn btn-sm btn-outline-danger border-0 p-1 shadow-none" 
                      title="Delete Task"
                      style={{ cursor: 'pointer' }}
                      onClick={() => onDelete && onDelete(item.id)}
                    >
                      <i className="fas fa-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className="text-center py-5 text-muted small italic">
                <i className="fas fa-tasks d-block mb-2 fa-2x opacity-25"></i>
                No tasks recorded for today.
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default NowDayTaskList;